module.exports = __webpack_public_path__ + "img/avatar-13.dae0a237.png";